// extracted by mini-css-extract-plugin
module.exports = {"block":"MobileNavMenu_block__3u4WK","navlink":"MobileNavMenu_navlink__2WNyV","loginlink":"MobileNavMenu_loginlink__C9sM7","logoutlink":"MobileNavMenu_logoutlink__2eDrG"};